import {listCodeRepositories} from './queries';
import {GraphQLQuery} from '@aws-amplify/api';
import {CodeRepository} from '../types';
import {pipelinesClient} from '../../pipelines-api-integration/client';

type ListCodeRepositories = {
    listCodeRepositories: { items: CodeRepository[]; nextToken?: string }
}

const client = pipelinesClient;

export const fetchRecords = async (query: {
    filter?: object;
    limit?: number;
    nextToken?: string | null;
}) => {
    const {filter, limit, nextToken} = query;
    const response = await client.graphql<GraphQLQuery<ListCodeRepositories>>({
        query: listCodeRepositories,
        variables: {filter, limit, nextToken},
    });
    return {
        items: response.data?.listCodeRepositories.items ?? [],
        nextToken: response.data?.listCodeRepositories.nextToken,
    };
};
